import React, { useState } from "react";
import { FaEdit } from "react-icons/fa";
import {
  FormField,
  PrimaryButton,
  SecondaryButton,
} from "../../../components/UI/DesignStandards";
import {
  formatPair,
  laneAssignmentLabel,
  pairStartFromLane,
} from "../../../utility/laneAssignment";

const DetailRow = ({ label, value }) => (
  <div>
    <div className="text-xs font-medium text-brand-muted mb-1">{label}</div>
    <div className="text-sm text-brand-charcoal">{value}</div>
  </div>
);

const laneInputFromTeam = (team) => {
  if (!team) return "";
  if (team.startingLane) return String(team.startingLane);
  if (team.startingPair) return String(team.startingPair);
  return "";
};

const TeamLaneCard = ({ team, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState("");
  const [saving, setSaving] = useState(false);

  const savedInput = laneInputFromTeam(team);
  const display = laneAssignmentLabel(team) || "Not assigned";
  const pairHint = formatPair(pairStartFromLane(draft));

  const handleStartEdit = () => {
    setDraft(savedInput);
    setIsEditing(true);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await onSave(draft);
      setIsEditing(false);
    } catch (error) {
      // Parent already notified.
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setDraft(savedInput);
    setIsEditing(false);
  };

  return (
    <div className="card-inset p-4 space-y-4 h-full">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="heading-display text-lg">Starting lane</h2>
        </div>
        {!isEditing ? (
          <SecondaryButton
            type="button"
            onClick={handleStartEdit}
            icon={FaEdit}
            className="!px-3 !py-2 text-sm flex-shrink-0"
          >
            Edit
          </SecondaryButton>
        ) : null}
      </div>

      {isEditing ? (
        <form onSubmit={handleSave} className="space-y-4">
          <FormField
            label="Starting lane"
            type="number"
            min="1"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="5"
          />
          {pairHint ? (
            <p className="text-sm text-brand-muted -mt-2">Pair {pairHint}</p>
          ) : (
            <p className="text-sm text-brand-muted -mt-2">
              Leave blank to remove the assignment.
            </p>
          )}
          <div className="flex flex-wrap gap-2">
            <PrimaryButton type="submit" loading={saving}>
              Save
            </PrimaryButton>
            <SecondaryButton type="button" onClick={handleCancel} disabled={saving}>
              Cancel
            </SecondaryButton>
          </div>
        </form>
      ) : (
        <DetailRow label="Starting lane" value={display} />
      )}
    </div>
  );
};

export default TeamLaneCard;
